import React, { useState, useEffect } from 'react'
import Spiner from '../../components/modals/Spiner'
import userLogic from '../../functions/logic/userLogic'
import generalLogic from '../../functions/logic/generalLogic'
import FormModal from '../../components/modals/FormModal'
import { useSnackbar } from 'notistack'
import '../../scss/checkout.scss'

export default function Checkout() {
  const [step, setStep] = useState('envio')
  const { enqueueSnackbar } = useSnackbar()
  const [spiner, setSpiner] = useState(false)
  const [defaultAddress, setDefaultAddress] = useState([])
  const [cartItems, setCartItems] = useState([])
  const [discountAmount, setDiscountAmount] = useState(0)
  const [shippings, setShippings] = useState([])
  const [payMethods, setPayMethods] = useState([])
  const [bankAccounts, setBankAccounts] = useState([])
  const [selectedShipping, setSelectedShipping] = useState('')
  const [ship, setEnvio] = useState(0)
  const [showModal, setShowModal] = useState(false)
  const [tittle, setTittle] = useState('')
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [payMethod, setPayMethod] = useState(null)

  useEffect(() => {
    setSpiner(true)
    getAddress()
    getViewCart()
    getShippingMethods()
    getPayMethod()
    setSpiner(false)
  }, [])

  const getAddress = async () => {
    const address = await userLogic.getAddressLogic(0, '')

    if (address.success && address.data.length > 0) {
      const mainAddress = address.data.find((addr) => addr.es_principal === 't')

      setDefaultAddress(mainAddress || null)
    }
  }

  const getPayMethod = async () => {
    const poyMethod = await generalLogic.getPayMethodLogic()

    if (poyMethod.success && poyMethod.data) {
      setPayMethods(poyMethod.data.metodoPago || [])
      setPayMethod(poyMethod.data.metodoPago[0])
      setBankAccounts(poyMethod.data.cta || [])
    } else {
      console.error('Error: No se pudieron cargar los métodos de pago.')
    }
  }

  const getShippingMethods = async () => {
    const shipping = await generalLogic.getShippingMethods()

    if (
      shipping.success &&
      Array.isArray(shipping.data) &&
      shipping.data.length > 0
    ) {
      setShippings(shipping.data)

      const storedShippingCode =
        localStorage.getItem('shippingCost') || 'TIPENV0001'

      const defaultShipping =
        shipping.data.find(
          (method) => method.nemonicoTiposEnvio === storedShippingCode
        ) || shipping.data[0]

      setSelectedShipping(defaultShipping)
      setEnvio(parseFloat(defaultShipping.costo))

      localStorage.setItem('shippingCost', defaultShipping.nemonicoTiposEnvio)

      const updatedCartItems = localStorage.getItem('cartItems')
      userLogic.saveViewCartLogic(updatedCartItems)
    } else {
      setShippings([])
      setSelectedShipping(null)
      setEnvio(0)
    }
  }

  const getViewCart = async () => {
    const storedCartItems = localStorage.getItem('cartItems')

    if (storedCartItems) {
      const parsedCartItems = JSON.parse(storedCartItems)
      setCartItems(parsedCartItems)
    }

    const storedDiscountAmount = localStorage.getItem('discountAmount')

    if (storedDiscountAmount) {
      setDiscountAmount(parseFloat(storedDiscountAmount))
    }
  }

  const getUnitPrice = (item) => {
    return parseFloat(item.precio_descuento) > 0
      ? parseFloat(item.precio_descuento)
      : item.price
  }

  const goToStep = (newStep) => {
    setStep(newStep)
  }

  const calculateTotals = () => {
    let subtotalIva15 = 0
    let subtotalIva0 = 0
    let totalIva = 0
    let totalIvaDescuento = 0

    cartItems.forEach((item) => {
      const unitPrice = getUnitPrice(item)
      const subtotal = unitPrice * item.quantity

      if (item.tarifa > 0) {
        subtotalIva15 += subtotal

        totalIva +=
          ((unitPrice * parseFloat(item.tarifa)) / 100) * item.quantity

        if (parseFloat(item.iva_descuento) > 0) {
          totalIvaDescuento += parseFloat(item.iva_descuento) * item.quantity
        }
      } else {
        subtotalIva0 += subtotal
      }
    })

    return {
      subtotalIva15,
      subtotalIva0,
      totalIva,
      totalIvaDescuento
    }
  }

  const { subtotalIva15, subtotalIva0, totalIva } = calculateTotals()

  const envio = ship
  const totalIvaFinal = totalIva

  const totalGeneral =
    subtotalIva15 + subtotalIva0 + totalIvaFinal + envio - discountAmount

  const handleShippingChange = (event) => {
    const selectedId = event.target.value

    const selected = shippings.find((method) => method.id === selectedId)

    if (selected) {
      setSelectedShipping(selected)
      setEnvio(parseFloat(selected.costo))

      localStorage.setItem('shippingCost', selected.nemonicoTiposEnvio)

      const updatedCartItems = localStorage.getItem('cartItems')

      userLogic.saveViewCartLogic(updatedCartItems)
    }
  }

  const handlePaymentMethodSelect = (method) => {
    setPayMethod(method)
  }

  const handleModalClose = () => {
    setShowModal(false)
    setSelectedAddress(null)
  }

  const handleModalShow = (address) => {
    setSpiner(true)
    setTittle('Actualizar dirección de envío')
    setSelectedAddress(address.defaultAddress)
    setShowModal(true)
    setSpiner(false)
    getAddress()
  }

  const handledSaveParam = async (event) => {
    setSpiner(true)
    event.preventDefault()

    const response = await userLogic.saveAddressLogic(event.target)

    enqueueSnackbar(response.message, {
      variant: response.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })

    if (response.success) {
      setShowModal(false)
      window.location.reload()
    }

    setSpiner(false)
  }

  const saveOrder = async (event) => {
    setSpiner(true)
    event.preventDefault()

    const BASENAME = ''

    const linkRastreo = BASENAME + global.ORDERCRASTREO

    const linkOrderDetail = BASENAME + global.ORDERDETAIL

    const linkOrderConfirm = BASENAME + global.ORDERCONFIRM

    const response = await userLogic.saveOrderLogic(
      payMethod,
      linkRastreo,
      linkOrderDetail,
      linkOrderConfirm
    )

    enqueueSnackbar(response.data.message, {
      variant: response.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })

    if (response.success) {
      window.location.href = response.data.url

      localStorage.removeItem('cartItems')
      localStorage.removeItem('discountAmount')
      localStorage.removeItem('discountCode')
      localStorage.removeItem('envio')
      localStorage.removeItem('shippingCost')
    }

    setSpiner(false)
  }

  return (
    <>
      <Spiner opt={spiner} />

      <FormModal
        isOpen={showModal}
        handleCloseModal={handleModalClose}
        header={tittle}
        button="Guardar"
        formData={selectedAddress || {}}
        handledSave={handledSaveParam}
        opt="addressInvoice"
      />

      <main className="main easybuy-checkout-page">
        <div className="page-content">
          <div className="checkout">
            <div className="container easybuy-checkout-container">
              <div className="easybuy-checkout-tabs">
                <ul className="easybuy-checkout-nav">
                  <li className="nav-item">
                    <button
                      className={`easybuy-checkout-tab ${
                        step === 'envio' ? 'active' : ''
                      }`}
                      onClick={() => goToStep('envio')}
                    >
                      <span className="checkout-step-number">1</span>

                      <span>Envío</span>

                      {step === 'pago' && <span className="check-icon">✓</span>}
                    </button>
                  </li>

                  <li className="nav-item">
                    <button
                      className={`easybuy-checkout-tab ${
                        step === 'pago' ? 'active' : ''
                      }`}
                      onClick={() => goToStep('pago')}
                      disabled={step === 'envio'}
                    >
                      <span className="checkout-step-number">2</span>

                      <span>Pago</span>
                    </button>
                  </li>
                </ul>
              </div>

              {step === 'envio' && (
                <div className="row gx-4 gy-4">
                  <div className="col-12 col-md-8">
                    <div className="easybuy-checkout-card">
                      <div className="easybuy-card-header">
                        <div>
                          <span className="easybuy-card-eyebrow">PASO 1</span>

                          <h3 className="easybuy-section-title">
                            Dirección de envío
                          </h3>
                        </div>
                      </div>

                      {defaultAddress && defaultAddress.id ? (
                        <div className="easybuy-address-box">
                          <div className="easybuy-address-icon">
                            <i className="icon-map-marker"></i>
                          </div>

                          <div className="easybuy-address-content">
                            <p className="easybuy-address-name">
                              <strong>
                                {defaultAddress.nombres}{' '}
                                {defaultAddress.apellidos}
                              </strong>
                            </p>

                            <p>
                              {defaultAddress.direccion},{' '}
                              {defaultAddress.codigo_postal ||
                                'Sin código postal'}
                            </p>

                            <p>
                              Provincia {defaultAddress.provincia_name}, Ciudad{' '}
                              {defaultAddress.canton_name}
                            </p>

                            <p>
                              {defaultAddress.telefono_contacto ||
                                'Sin teléfono de contacto'}
                            </p>

                            <p>
                              {defaultAddress.referencia || 'Sin referencia'}
                            </p>

                            <p className="easybuy-address-default">
                              ✓ Esta es tu dirección de envío por defecto
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="easybuy-empty-address">
                          <i className="icon-warning"></i>

                          <div>
                            <strong>
                              No tienes una dirección principal configurada
                            </strong>

                            <p>
                              Para continuar con la compra, ingresa una
                              dirección.
                            </p>
                          </div>
                        </div>
                      )}

                      <div className="easybuy-card-divider"></div>

                      <div className="easybuy-address-actions">
                        {defaultAddress && defaultAddress.id && (
                          <button
                            className="easybuy-secondary-btn"
                            onClick={() =>
                              handleModalShow({
                                defaultAddress
                              })
                            }
                          >
                            <i className="icon-edit"></i>
                            Editar dirección
                          </button>
                        )}

                        <button
                          className="easybuy-secondary-btn light"
                          onClick={() => handleModalShow({})}
                        >
                          <i className="icon-plus"></i>
                          Nueva dirección
                        </button>
                      </div>
                    </div>

                    <div className="easybuy-checkout-card">
                      <div className="easybuy-card-header">
                        <div>
                          <span className="easybuy-card-eyebrow">ENTREGA</span>

                          <h3 className="easybuy-section-title">
                            Métodos de envío
                          </h3>
                        </div>
                      </div>

                      <div className="shipping-methods">
                        <label
                          htmlFor="shippingMethod"
                          className="shipping-select-label"
                        >
                          Método de envío
                        </label>

                        <select
                          id="shippingMethod"
                          className="shipping-select"
                          value={selectedShipping?.id || ''}
                          onChange={handleShippingChange}
                        >
                          {shippings.map((shipping) => (
                            <option key={shipping.id} value={shipping.id}>
                              {shipping.nombre} - $
                              {parseFloat(shipping.costo).toFixed(2)} -{' '}
                              {parseInt(shipping.dias)} días
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-4">
                    <div className="easybuy-checkout-card easybuy-order-summary">
                      <span className="easybuy-card-eyebrow">TU COMPRA</span>

                      <h3 className="easybuy-section-title">
                        Resumen de tu pedido
                      </h3>

                      <div className="easybuy-order-totals">
                        <p>
                          <span>Subtotal IVA 15%:</span>
                          <span>${subtotalIva15.toFixed(2)}</span>
                        </p>

                        <p>
                          <span>Subtotal IVA 0%:</span>
                          <span>${subtotalIva0.toFixed(2)}</span>
                        </p>

                        <p>
                          <span>IVA Total:</span>
                          <span>${totalIva.toFixed(2)}</span>
                        </p>

                        <p>
                          <span>
                            Envío:{' '}
                            {selectedShipping
                              ? selectedShipping.nombre
                              : 'No seleccionado'}
                          </span>

                          <span>${ship.toFixed(2)}</span>
                        </p>

                        {discountAmount > 0 && (
                          <p className="discount-line">
                            <span>Descuento aplicado:</span>

                            <span>-${discountAmount.toFixed(2)}</span>
                          </p>
                        )}

                        <hr className="easybuy-summary-line" />

                        <p className="easybuy-order-total">
                          <span>Total:</span>

                          <span>${totalGeneral.toFixed(2)}</span>
                        </p>
                      </div>
                    </div>

                    <div className="easybuy-checkout-card">
                      <span className="easybuy-card-eyebrow">PRODUCTOS</span>

                      <h3 className="easybuy-section-title">
                        Carrito ({cartItems.length} productos)
                      </h3>

                      <ul className="easybuy-order-items">
                        {cartItems.map((item) => {
                          const unitPrice =
                            parseFloat(item.precio_descuento) > 0
                              ? parseFloat(item.precio_descuento)
                              : item.price

                          const originalPrice = parseFloat(item.price)

                          return (
                            <li key={item.id} className="easybuy-order-item">
                              <img
                                src={
                                  item.imageUrl.startsWith('http')
                                    ? item.imageUrl
                                    : `${global.IMGProd}${item.imageUrl}`
                                }
                                alt={item.name}
                                className="easybuy-order-item-image"
                              />

                              <div className="easybuy-order-item-info">
                                <p className="easybuy-product-name">
                                  {item.name}
                                </p>

                                <p>Cantidad: {item.quantity}</p>

                                <p className="easybuy-product-price">
                                  {unitPrice < originalPrice ? (
                                    <>
                                      <span className="original-price">
                                        ${originalPrice.toFixed(2)}
                                      </span>

                                      <span className="discount-price">
                                        ${unitPrice.toFixed(2)}
                                      </span>
                                    </>
                                  ) : (
                                    <span>${originalPrice.toFixed(2)}</span>
                                  )}
                                </p>
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </div>

                    {defaultAddress && defaultAddress.id && (
                      <button
                        className="easybuy-primary-btn checkout-continue-btn"
                        onClick={() => goToStep('pago')}
                      >
                        <span>Continuar a Pago</span>
                        <i className="la la-arrow-right"></i>
                      </button>
                    )}
                  </div>
                </div>
              )}

              {step === 'pago' && (
                <div className="row gx-4 gy-4">
                  <div className="col-12 col-md-8">
                    <div className="easybuy-checkout-card">
                      <span className="easybuy-card-eyebrow">PASO 2</span>

                      <h3 className="easybuy-section-title">Método de pago</h3>

                      <div className="easybuy-payment-methods">
                        {payMethods.map((method) => (
                          <div
                            className={`easybuy-payment-option ${
                              payMethod?.nemonico_metodos_pago ===
                              method.nemonico_metodos_pago
                                ? 'selected'
                                : ''
                            }`}
                            key={method.nemonico_metodos_pago}
                            onClick={() => handlePaymentMethodSelect(method)}
                          >
                            <input
                              type="radio"
                              name="paymentMethod"
                              value={method.nemonico_metodos_pago}
                              checked={
                                payMethod?.nemonico_metodos_pago ===
                                method.nemonico_metodos_pago
                              }
                              onChange={() => handlePaymentMethodSelect(method)}
                            />

                            <div className="easybuy-payment-option-content">
                              <strong>{method.nombre}</strong>
                              <small>{method.descripcion}</small>
                            </div>
                          </div>
                        ))}

                        {payMethod?.nemonico_metodos_pago === 'METPA0004' &&
                          bankAccounts.length > 0 && (
                            <div className="easybuy-bank-section">
                              <div className="easybuy-bank-accounts">
                                {bankAccounts.map((account) => (
                                  <div
                                    className="easybuy-bank-account-card"
                                    key={account.nemonico_cta_bank}
                                  >
                                    <div className="easybuy-bank-account-header">
                                      <h5>{account.banco}</h5>
                                      <span>{account.tipo_cta}</span>
                                    </div>

                                    <div className="easybuy-bank-account-details">
                                      <p>
                                        <strong>Número de cuenta:</strong>{' '}
                                        {account.num_cta}
                                      </p>

                                      <p>
                                        <strong>Titular:</strong>{' '}
                                        {account.nombres}
                                      </p>

                                      <p>
                                        <strong>Identificación:</strong>{' '}
                                        {account.identificacion}
                                      </p>

                                      <p>
                                        <strong>Correo:</strong>{' '}
                                        {account.correo}
                                      </p>
                                    </div>
                                  </div>
                                ))}
                              </div>

                              <div className="easybuy-transfer-note">
                                <i className="la la-info-circle"></i>

                                <span>
                                  Cuando generes la orden, dirígete a tus
                                  órdenes pendientes y podrás subir tu
                                  comprobante de transferencia.
                                </span>
                              </div>
                            </div>
                          )}
                      </div>

                      <div className="easybuy-finish-order">
                        <div>
                          <span className="easybuy-card-eyebrow">
                            CONFIRMACIÓN
                          </span>

                          <h3 className="easybuy-section-title">
                            Finaliza tu pedido
                          </h3>

                          <p>
                            Revisa la información antes de confirmar tu compra.
                          </p>
                        </div>

                        <button
                          className="easybuy-primary-btn"
                          onClick={(e) => saveOrder(e)}
                        >
                          Finalizar pedido
                          <i className="la la-check"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-4">
                    <div className="easybuy-checkout-card easybuy-order-summary">
                      <span className="easybuy-card-eyebrow">TU COMPRA</span>

                      <h3 className="easybuy-section-title">
                        Resumen de tu pedido
                      </h3>

                      <div className="easybuy-order-totals">
                        <p>
                          <span>Subtotal IVA 15%:</span>
                          <span>${subtotalIva15.toFixed(2)}</span>
                        </p>

                        <p>
                          <span>Subtotal IVA 0%:</span>
                          <span>${subtotalIva0.toFixed(2)}</span>
                        </p>

                        <p>
                          <span>IVA Total:</span>
                          <span>${totalIva.toFixed(2)}</span>
                        </p>

                        <p>
                          <span>
                            Envío:{' '}
                            {selectedShipping
                              ? selectedShipping.nombre
                              : 'No seleccionado'}
                          </span>

                          <span>${ship.toFixed(2)}</span>
                        </p>

                        {discountAmount > 0 && (
                          <p className="discount-line">
                            <span>Descuento aplicado:</span>

                            <span>-${discountAmount.toFixed(2)}</span>
                          </p>
                        )}

                        <hr className="easybuy-summary-line" />

                        <p className="easybuy-order-total">
                          <span>Total:</span>

                          <span>${totalGeneral.toFixed(2)}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
